import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { Modal } from "@ui/components";
import { Box, Button, Icon, Text, Title } from "@ui/elements";
import { Cell, Grid, Stack } from "@ui/layout";

import { CommonModalProps } from "@components";

export const TipTypeInfoModal: FC<CommonModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isActive={isOpen}
      onClose={onClose}
      header={
        <Stack align="center">
          <Icon icon="Info" />
          <Title size={4}>{t("tipTypes.header")}</Title>
        </Stack>
      }
      style={{ zIndex: 100 }}
      footer={
        <Stack justify="end" isFullwidth>
          <Button variant="light" onClick={onClose}>
            {t("tipTypes.close")}
          </Button>
        </Stack>
      }
    >
      <Stack direction="column" gap="xl">
        <Stack direction="column" gap="xl">
          <Title size={6}>{t("tipTypes.descriptionTitle")}</Title>
          <Text>{t("tipTypes.descriptionText")}</Text>
        </Stack>

        <Grid minColWidth={11}>
          <Cell>
            <Box>
              <Stack direction="column" gap="lg">
                <Title size={6}>
                  <Stack align="center" gap="xs">
                    <Icon icon="Target" />
                    <span>{t("tipTypes.resultOriented.title")}</span>
                  </Stack>
                </Title>
                <Text>{t("tipTypes.resultOriented.description")}</Text>
                <Stack direction="column">
                  <Stack gap="sm">
                    <Icon icon="CheckCircle" />
                    {t("tipTypes.resultOriented.bulletPoint1")}
                  </Stack>
                  <Stack gap="sm">
                    <Icon icon="CheckCircle" />
                    {t("tipTypes.resultOriented.bulletPoint2")}
                  </Stack>
                  <Stack gap="sm">
                    <Icon icon="CheckCircle" />
                    {t("tipTypes.resultOriented.bulletPoint3")}
                  </Stack>
                  <Stack gap="sm">
                    <Icon icon="CheckCircle" />
                    {t("tipTypes.resultOriented.bulletPoint4")}
                  </Stack>
                  <Stack gap="sm">
                    <Icon icon="CheckCircle" />
                    {t("tipTypes.resultOriented.bulletPoint5")}
                  </Stack>
                </Stack>
              </Stack>
            </Box>
          </Cell>
          <Cell>
            <Box>
              <Stack direction="column" gap="lg">
                <Title size={6}>
                  <Stack align="center" gap="xs">
                    <Icon icon="ChartBar" />
                    <span>{t("tipTypes.valueBased.title")}</span>
                  </Stack>
                </Title>
                <Text>{t("tipTypes.valueBased.description")}</Text>
                <Stack direction="column">
                  <Stack gap="sm">
                    <Icon icon="CheckCircle" />
                    {t("tipTypes.valueBased.bulletPoint1")}
                  </Stack>
                  <Stack gap="sm">
                    <Icon icon="CheckCircle" />
                    {t("tipTypes.valueBased.bulletPoint2")}
                  </Stack>
                  <Stack gap="sm">
                    <Icon icon="CheckCircle" />
                    {t("tipTypes.valueBased.bulletPoint3")}
                  </Stack>
                  <Stack gap="sm">
                    <Icon icon="CheckCircle" />
                    {t("tipTypes.valueBased.bulletPoint4")}
                  </Stack>
                  <Stack gap="sm">
                    <Icon icon="CheckCircle" />
                    {t("tipTypes.valueBased.bulletPoint5")}
                  </Stack>
                </Stack>
              </Stack>
            </Box>
          </Cell>
        </Grid>
      </Stack>
    </Modal>
  );
};
